<template>
  <a href="#" @click.prevent="open" :class="'vda-link'"></a>
</template>

<style lang="scss">
.vda-link {
  margin-top: 8px;
  display: inline-flex;
	align-self: center;
  justify-content: center;
  font-size: 14px;
  &:after {
    content: 'Advertisement';
    display: inline-flex;
  }
}
</style>

<script>
export default {
  props: {
    type: String,
    href: String,
  },
  data: () => ({
    
  }),
  methods: {
    open() {
      let t = this.$root.isMobile ? 'mobile':'desktop';
      window.open(`https://clickadilla.com/?ref=tyH4jl5H&utm_source=getsex&utm_content=${t}_${this.type}`);
    }
  }
}
</script>
